import { Col, Row } from 'antd'
import React from 'react'

import { FileDisplay } from '@/components'
import { LocalFileFragment } from '@/generated/graphql'

import s from './post-card.module.less'

interface PostFilesProps {
  files: LocalFileFragment[]
}

export const PostCardFiles: React.FC<PostFilesProps> = ({ files }) => {
  if (files.length === 0) {
    return null
  }

  const isImage = (type: string) => type.split('/')[0] === 'image'
  const images = files.filter((f) => isImage(f.type))

  const elements = files.map((f) => (
    <Col key={f.fileId} className={s.col} span={files.length === 1 || !isImage(f.type) ? 24 : 12}>
      <FileDisplay file={f} images={images} width='100%' height='auto' showDownload />
    </Col>
  ))

  return (
    <div className={s.filesContainer}>
      <Row gutter={[4, 4]}>{elements}</Row>
    </div>
  )
}
